// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selWidth[data-v-596034c6] {\n  width: 300px;\n}", ""]);
// Exports
module.exports = exports;
